import { useLogoUrl } from './useLogo';

const initialsOf = (name: string): string => {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    if (words.length === 1) return words[0]!.slice(0, 2).toUpperCase();
    return (words[0]![0]! + words[words.length - 1]![0]!).toUpperCase();
};

/**
 * The company's own mark, secondary to the Timely Payment mark beside it.
 *
 * A logo is optional; a company name is not (0010's own reasoning) — so a
 * company with none shows its initials, deliberately, rather than a blank
 * square that reads as broken chrome. Upload or delete never leaves this
 * without something to show: the fallback needs nothing that a failed
 * request could take away.
 */
export function CompanyMark({ name, logoPath, onChrome = false, size = 'sm' }: {
    name: string; logoPath: string | null;
    /** On the navy frame: initials in white on a lighter navy. */
    onChrome?: boolean;
    size?: 'sm' | 'md';
}) {
    const url = useLogoUrl(logoPath);
    const box = size === 'md' ? 'w-8 h-8' : 'w-6 h-6';

    if (logoPath && url) {
        return (
            <img
                src={url} alt={`${name} logo`}
                className={`${box} rounded-sm object-cover flex-none ${onChrome ? 'bg-chrome-label' : 'bg-card-3'}`}
            />
        );
    }

    return (
        <span
            className={`${box} rounded-sm grid place-items-center font-semibold text-caption flex-none ${onChrome ? 'bg-chrome-3 text-chrome-label' : 'bg-card-3 text-label-2'}`}
            aria-hidden="true"
        >
            {initialsOf(name)}
        </span>
    );
}
